<template>
  <template v-for="o in relatedObjects">
    <div class="font-bold flex">
      <i class="tw-icon user-regular-blue"/>
      <a :class="`${o.contact.status === 'archived' ? 'tw-link-archived'  : 'tw-link'}`" :href="`/#/contacts/${o.uid}`">{{o.contact.full_name}}</a>
    </div>
  </template>
</template>
<script>
export default {
  props: {
    relateds: {type: Array, required: true},
  },
  data: ()=>({
    relatedObjects: []
  }),
  watch: {
    relateds: {
      handler(){
        this.fetchRelated()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    fetchRelated() {
      const reqs = {}
      for (const related of this.relateds) {
        const uid = related.data.R ? related.data.R.contact_uid : related.data.contact_uid;
        if (reqs[uid]) continue;

        const req = uid ?
            this.axios.get(`/contacts/${uid}/full_name`).
            then(resp => ({ uid, contact: resp.data }))
            : Promise.resolve('Not Loaded')
        reqs[uid] = req
      }
      return Promise.all(Object.values(reqs)).then(arr=>
          this.relatedObjects = arr.sort(
              (a,b)=> a.contact.full_name.localeCompare(b.contact.full_name, 'en', { sensitivity: 'base' })
          )
      )
    },
  }
}
</script>